import * as cl from "classnames"
import * as React from "react"
import { Instruction } from "../../../model"

export default class InstructionField extends React.Component<Props> {
	static id = "local-authority-detail-instruction"

	render() {
		return <div className="field">
			<label className="label" htmlFor={InstructionField.id}>Instruction</label>

			<span className="field-body">
				<span className="field">
					<span className="control">
						<span className={cl("select is-fullwidth", { "is-loading": this.props.loading })}>
							<select
							disabled={this.props.loading}
							id={InstructionField.id}
							required
							value={this.props.value || ""}
							onChange={e => this.props.onChange(parseInt(e.target.value))}>
								<option value="" disabled>Sélectionner une instruction</option>
								{this.props.instructions.map((instruction, i) =>
								<option key={i} value={instruction.id}>{instruction.name}</option>)}
							</select>
						</span>
					</span>
				</span>
			</span>
		</div>
	}
}

interface Props {
	instructions: Instruction[];
	loading: boolean;
	value: number;
	onChange(value: number): void;
}



// WEBPACK FOOTER //
// ./src/component/page/local-authority-detail-page/instruction-field.tsx